import Keycloak from 'keycloak-js';

const keycloak = new Keycloak({
  url: process.env.REACT_APP_KEYCLOAK_URL || 'http://localhost:8484',
  realm: process.env.REACT_APP_KEYCLOAK_REALM || 'omar_mobility',
  clientId: process.env.REACT_APP_KEYCLOAK_CLIENT_ID || 'omar',
});

keycloak.onTokenExpired = () => {
  console.log('Token expired, attempting to refresh...');
  keycloak.updateToken(30).then((refreshed: boolean) => {
    if (refreshed) {
      console.log('Token refreshed successfully');
    } else {
      const exp = keycloak.tokenParsed?.exp || 0;
      const timeSkew = keycloak.timeSkew || 0;
      console.warn('Token not refreshed, valid for only ' + Math.round(exp + timeSkew - new Date().getTime() / 1000) + ' seconds');
    }
  }).catch((error) => {
    console.error('Failed to refresh token', error);
    // Optionally redirect to login
    keycloak.login();
  });
};

export default keycloak;
